import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import Footer from "../../../customComponents/Footer";
import "./token-premium.css";

const TokenPage = () => {
    const [copied, setCopied] = useState(false);
    const [chartTimeframe, setChartTimeframe] = useState("1W");

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const handleCopy = () => {
        navigator.clipboard.writeText("0x4a2f...d3c9");
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const paymentUseCases = [
        {
            icon: "/images/token-img/agce_payment_icon.svg",
            title: "Platform Fees",
            desc: "Pay trading and platform fees at discounted rates.",
        },
        {
            icon: "/images/token-img/agce_payment_icon2.svg",
            title: "Cross-Chain Swaps",
            desc: "Use AGCX across multiple blockchain networks seamlessly.",
        },
        {
            icon: "/images/token-img/agce_payment_icon3.svg",
            title: "DeFi Yield",
            desc: "Participate in liquidity pools and earn DeFi rewards.",
        },
        {
            icon: "/images/token-img/agce_payment_icon4.svg",
            title: "Governance Voting",
            desc: "Shape the future of AGCX through community votes.",
        },
    ];

    return (
        <>
            <Helmet>
                <title>AGCX Token | Powering Decentralized Tomorrow</title>
                <meta
                    name="description"
                    content="AGCX is the native utility token of the AGCX ecosystem, driving innovation, community growth, and long-term value."
                />
            </Helmet>

            <div className="token-page">
                <div className="token-container">

                    {/* ========================================== */}
                    {/* --- 1. HERO SECTION --- */}
                    {/* ========================================== */}
                    <div className="token-hero">
                        <div className="token-hero-left">
                            <h1 className="token-hero-title">
                                Powering <br />
                                Decentralized <span className="gold-text">Tomorrow</span>
                            </h1>
                            <p className="token-hero-desc">
                                AGCX is the native utility token of the AGCX ecosystem, driving innovation, community growth, and long-term value.
                            </p>
                            <div className="token-hero-btns">
                                <Link to="/buy_crypto" className="buybtn">
                                    Buy AGCX
                                </Link>
                                <a href="#whitepaper" className="whitepaperbtn">
                                    Whitepaper <i className="ri-external-link-line"></i>
                                </a>
                            </div>
                            <div className="contract-address-box">
                                <span>Contract:</span>
                                <span className="contract-code">0x4a2f...d3c9</span>
                                <button type="button" className="copy-btn" onClick={handleCopy}>
                                    <i className="ri-file-copy-line"></i> {copied ? "Copied!" : "Copy"}
                                </button>
                            </div>
                        </div>

                        <div className="token-hero-right">
                            <div className="floating-pill top-right">Built for Web 3</div>
                            <div className="floating-pill middle-left">Decentralized</div>
                            <img
                                src="/images/token-img/token_bnr_img.png"
                                alt="AGCX Token Graphic"
                            />
                        </div>
                    </div>

                </div>

                {/* ========================================== */}
                {/* --- 2. KEY METRICS STATS BAR --- */}
                {/* ========================================== */}
                <div className="tokenlist_value">
                    <div className="token-container">
                        <div className="token-metrics-bar">
                            <div className="metric-stat-item">
                                <span className="metric-stat-value">1,000,000,000</span>
                                <span className="metric-stat-label">Total Supply / AGCX</span>
                                <span className="sub-label">AGCX</span>
                            </div>
                            <div className="metric-stat-item">
                                <span className="metric-stat-value">345,632,143</span>
                                <span className="metric-stat-label">Circulating Supply</span>
                                <span className="sub-label">AGCX</span>
                            </div>
                            <div className="metric-stat-item">
                                <span className="metric-stat-value">$76,543,000</span>
                                <span className="metric-stat-label">Market Cap</span>
                                <span className="sub-label">USD</span>
                            </div>
                            <div className="metric-stat-item">
                                <span className="metric-stat-value">$0.9278</span>
                                <span className="metric-stat-label">Token Price</span>
                                <span className="sub-label">USDT</span>
                            </div>
                            <div className="metric-stat-item">
                                <span className="metric-stat-value">125,000+</span>
                                <span className="metric-stat-label">Token Holders</span>
                                <span className="sub-label">Users</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="token-container">

                    {/* ========================================== */}
                    {/* --- 3. WHY AGCX SECTION --- */}
                    {/* ========================================== */}
                    <div className="why-agce-section">
                        <div className="section-header-center">
                            <h2>Why AGCX?</h2>
                        </div>
                        <div className="diamond-flow-wrapper">

                            <div className="diamond-flow-container">
                                {/* Item 1: Utility Token */}
                                <div className="diamond-col is-top">
                                    <img
                                        src="/images/token-img/why_agce_vector_list2.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector dark_img"
                                    />
                                    <img
                                        src="/images/token-img/why_agce_vector_list2_light.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector light_img"
                                    />
                                    <div className="diamond-icon-box">
                                        <img src="/images/token-img/token_agce_icon.svg" alt="Utility Token" />
                                    </div>
                                    <div className="diamond-text-content">
                                        <h3>Utility Token</h3>
                                        <p>Power transactions across the entire AGCX ecosystem.</p>
                                    </div>
                                </div>

                                {/* Item 2: Low Fees */}
                                <div className="diamond-col is-bottom">
                                    <img
                                        src="/images/token-img/why_agce_vector_list.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector dark_img"
                                    />
                                    <img
                                        src="/images/token-img/why_agce_vector_list_light.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector light_img"
                                    />
                                    <div className="diamond-text-content">
                                        <h3>Low Fees</h3>
                                        <p>Minimal gas fees with optimized smart contracts.</p>
                                    </div>
                                    <div className="diamond-icon-box">
                                        <img src="/images/token-img/token_agce_icon6.svg" alt="Low Fees" />
                                    </div>
                                </div>

                                {/* Item 3: Fast & Scalable */}
                                <div className="diamond-col is-top">
                                    <img
                                        src="/images/token-img/why_agce_vector_list2.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector dark_img"
                                    />
                                    <img
                                        src="/images/token-img/why_agce_vector_list2_light.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector light_img"
                                    />
                                    <div className="diamond-icon-box">
                                        <img src="/images/token-img/token_agce_icon2.svg" alt="Fast & Scalable" />
                                    </div>
                                    <div className="diamond-text-content">
                                        <h3>Fast & Scalable</h3>
                                        <p>High-throughput blockchain for instant settlements.</p>
                                    </div>
                                </div>

                                {/* Item 4: Safe & Transparent */}
                                <div className="diamond-col is-bottom">
                                    <img
                                        src="/images/token-img/why_agce_vector_list.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector dark_img"
                                    />
                                    <img
                                        src="/images/token-img/why_agce_vector_list_light.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector light_img"
                                    />
                                    <div className="diamond-text-content">
                                        <h3>Safe & Transparent</h3>
                                        <p>Audited contracts and full on-chain transparency.</p>
                                    </div>
                                    <div className="diamond-icon-box">
                                        <img src="/images/token-img/token_agce_icon3.svg" alt="Safe & Transparent" />
                                    </div>
                                </div>

                                {/* Item 5: Community Pay */}
                                <div className="diamond-col is-top">
                                    <img
                                        src="/images/token-img/why_agce_vector_list2.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector dark_img"
                                    />
                                    <img
                                        src="/images/token-img/why_agce_vector_list2_light.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector light_img"
                                    />
                                    <div className="diamond-icon-box">
                                        <img src="/images/token-img/token_agce_icon4.svg" alt="Community Pay" />
                                    </div>
                                    <div className="diamond-text-content">
                                        <h3>Community Pay</h3>
                                        <p>Reward active community members with token payouts.</p>
                                    </div>
                                </div>

                                {/* Item 6: Staking Benefit */}
                                <div className="diamond-col is-bottom">
                                    <img
                                        src="/images/token-img/why_agce_vector_list.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector dark_img"
                                    />
                                    <img
                                        src="/images/token-img/why_agce_vector_list_light.png"
                                        alt="Why AGCX Diagram Line"
                                        className="why-agce-bg-vector light_img"
                                    />
                                    <div className="diamond-text-content">
                                        <h3>Staking Benefit</h3>
                                        <p>Earn passive rewards through flexible staking pools.</p>
                                    </div>
                                    <div className="diamond-icon-box">
                                        <img src="/images/token-img/token_agce_icon5.svg" alt="Staking Benefit" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ========================================== */}
                    {/* --- 4. ECOSYSTEM & TOKENOMICS GRID --- */}
                    {/* ========================================== */}
                    <div className="tokenomics-grid-section">
                        {/* Top Row Cards */}
                        <div className="token-cards-grid">
                            {/* Card 1: AGCX Price */}
                            <div className="token-card">
                                <span className="metric-stat-label">AGCX Price</span>
                                <div className="price-header">
                                    <div className="price-value-box">
                                        <span className="price-main">$1.46</span>
                                        <span className="badge-positive">↗ +12.4%</span>
                                    </div>
                                    <div className="time-filters">
                                        {["1D", "1W", "1M"].map((tf) => (
                                            <button
                                                key={tf}
                                                className={`filter-btn ${chartTimeframe === tf ? "active" : ""}`}
                                                onClick={() => setChartTimeframe(tf)}
                                            >
                                                {tf}
                                            </button>
                                        ))}
                                    </div>
                                </div>

                                <div className="chart-bars-mock">
                                    <div className="chart-bar" style={{ height: "30%" }}></div>
                                    <div className="chart-bar" style={{ height: "45%" }}></div>
                                    <div className="chart-bar" style={{ height: "35%" }}></div>
                                    <div className="chart-bar" style={{ height: "60%" }}></div>
                                    <div className="chart-bar" style={{ height: "50%" }}></div>
                                    <div className="chart-bar" style={{ height: "70%" }}></div>
                                    <div className="chart-bar" style={{ height: "65%" }}></div>
                                    <div className="chart-bar" style={{ height: "85%" }}></div>
                                    <div className="chart-bar highlight" style={{ height: "100%" }}></div>
                                </div>

                                <p className="chart-footer-note">↗ 7-day price movement</p>
                            </div>

                            {/* Card 2: AGCX Benefits & Circulation */}

                            <div className="token_mid_p">

                                <div className="token-card">
                                    <h3 className="token-card-title">AGCX Benefits</h3>
                                    <div className="benefits-list">
                                        <div className="benefit-item-row">
                                            <div className="benefit-icon-badge">
                                                <img src="/images/token-img/benefits_icon.svg" alt="Launchpad Access" />
                                            </div>
                                            <div className="benefit-item-text">
                                                <h4>Launchpad Access</h4>
                                                <p>Priority access to exclusive IDOs and token launches.</p>
                                            </div>
                                        </div>
                                        <div className="benefit-item-row">
                                            <div className="benefit-icon-badge">
                                                <img src="/images/token-img/benefits_icon2.svg" alt="Staking Rewards" />
                                            </div>
                                            <div className="benefit-item-text">
                                                <h4>Staking Rewards</h4>
                                                <p>Earn up to 60% APY by staking AGCX in flexible pools.</p>
                                            </div>
                                        </div>
                                        <div className="benefit-item-row">
                                            <div className="benefit-icon-badge">
                                                <img src="/images/token-img/benefits_icon3.svg" alt="Trading Discounts" />
                                            </div>
                                            <div className="benefit-item-text">
                                                <h4>Trading Discounts</h4>
                                                <p>Reduced fees and exclusive discounts across AGCX services.</p>
                                            </div>
                                        </div>
                                        <div className="benefit-item-row">
                                            <div className="benefit-icon-badge">
                                                <img src="/images/token-img/benefits_icon4.svg" alt="DAO Governance" />
                                            </div>
                                            <div className="benefit-item-text">
                                                <h4>DAO Governance</h4>
                                                <p>Vote on protocol upgrades and platform proposals.</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                <div className="token-card">

                                    <h3 className="token-card-title">
                                        AGCX Circulation
                                    </h3>
                                    <div className="circulation-bars">
                                        <div className="circ-row">
                                            <span className="circ-label">Public Sale</span>
                                            <div className="circ-bar-bg">
                                                <div className="circ-bar-fill public-sale" style={{ width: "35%" }}></div>
                                            </div>
                                            <span className="circ-val">35%</span>
                                        </div>
                                        <div className="circ-row">
                                            <span className="circ-label">Ecosystem</span>
                                            <div className="circ-bar-bg">
                                                <div className="circ-bar-fill ecosystem" style={{ width: "25%" }}></div>
                                            </div>
                                            <span className="circ-val">25%</span>
                                        </div>
                                        <div className="circ-row">
                                            <span className="circ-label">Team</span>
                                            <div className="circ-bar-bg">
                                                <div className="circ-bar-fill team" style={{ width: "20%" }}></div>
                                            </div>
                                            <span className="circ-val">20%</span>
                                        </div>
                                        <div className="circ-row">
                                            <span className="circ-label">Reserve</span>
                                            <div className="circ-bar-bg">
                                                <div className="circ-bar-fill reserve" style={{ width: "12%" }}></div>
                                            </div>
                                            <span className="circ-val">12%</span>
                                        </div>
                                        <div className="circ-row">
                                            <span className="circ-label">Marketing</span>
                                            <div className="circ-bar-bg">
                                                <div className="circ-bar-fill marketing" style={{ width: "8%" }}></div>
                                            </div>
                                            <span className="circ-val">8%</span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Card 3: AGCX Payment Use Cases */}
                            <div className="token-card">
                                <h3 className="token-card-title">AGCX Payment Use Cases</h3>
                                <div className="usecases-list">
                                    {paymentUseCases.map((uc, idx) => (
                                        <div className="usecase-item" key={idx}>
                                            <div className="usecase-icon-box">
                                                <img src={uc.icon} alt={uc.title} />
                                            </div>
                                            <div className="usecase-text">
                                                <h4>{uc.title}</h4>
                                                <p>{uc.desc}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>

                        {/* Bottom Row Cards */}
                        <div className="bottom-cards-grid">
                            {/* Card 4: Built for Interoperability */}
                            <div className="token-card">
                                <h3 className="token-card-title">Built for Interoperability</h3>
                                <div className="chains-row">
                                    <div className="chain-badge">
                                        <div className="chain-circle eth">ETH</div>
                                        <span className="chain-name">ETH</span>
                                    </div>
                                    <div className="chain-badge">
                                        <div className="chain-circle bnb">BNB</div>
                                        <span className="chain-name">BNB</span>
                                    </div>
                                    <div className="chain-badge">
                                        <div className="chain-circle pol">POL</div>
                                        <span className="chain-name">POL</span>
                                    </div>
                                    <div className="chain-badge">
                                        <div className="chain-circle ava">AVA</div>
                                        <span className="chain-name">AVA</span>
                                    </div>
                                    <div className="chain-badge">
                                        <div className="chain-circle sol">SOL</div>
                                        <span className="chain-name">SOL</span>
                                    </div>
                                    <div className="chain-badge">
                                        <div className="chain-circle arb">ARB</div>
                                        <span className="chain-name">ARB</span>
                                    </div>
                                </div>
                                <Link to="/about_us" className="interop-link">
                                    View All Integrations ›
                                </Link>
                            </div>

                            {/* Card 5: Roadmap */}
                            <div className="token-card">
                                <h3 className="token-card-title">Roadmap</h3>
                                <div className="roadmap-list">
                                    <div className="roadmap-item">
                                        <div className="roadmap-left">
                                            <div className="roadmap-icon done">
                                                <i className="ri-checkbox-circle-line"></i>
                                            </div>
                                            <div className="roadmap-text">
                                                <span className="roadmap-quarter done">Q1 2025</span>
                                                <span className="roadmap-title">Token Launch & CEX Listing</span>
                                            </div>
                                        </div>
                                        <span className="roadmap-status-badge done">Done</span>
                                    </div>

                                    <div className="roadmap-item">
                                        <div className="roadmap-left">
                                            <div className="roadmap-icon done">
                                                <i className="ri-checkbox-circle-line"></i>
                                            </div>
                                            <div className="roadmap-text">
                                                <span className="roadmap-quarter done">Q2 2025</span>
                                                <span className="roadmap-title">Staking Platform & Launchpad Beta</span>
                                            </div>
                                        </div>
                                        <span className="roadmap-status-badge done">Done</span>
                                    </div>

                                    <div className="roadmap-item">
                                        <div className="roadmap-left">
                                            <div className="roadmap-icon soon">
                                                <i className="ri-checkbox-circle-line"></i>
                                            </div>
                                            <div className="roadmap-text">
                                                <span className="roadmap-quarter soon">Q3 2025</span>
                                                <span className="roadmap-title">Cross-Chain Bridge & DAO Launch</span>
                                            </div>
                                        </div>
                                        <span className="roadmap-status-badge soon">Soon</span>
                                    </div>

                                    <div className="roadmap-item">
                                        <div className="roadmap-left">
                                            <div className="roadmap-icon soon">
                                                <i className="ri-checkbox-circle-line"></i>
                                            </div>
                                            <div className="roadmap-text">
                                                <span className="roadmap-quarter soon">Q4 2025</span>
                                                <span className="roadmap-title">NFT Marketplace & DeFi Expansion</span>
                                            </div>
                                        </div>
                                        <span className="roadmap-status-badge soon">Soon</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* ========================================== */}
                    {/* --- 5. LATEST AGCX NEWS --- */}
                    {/* ========================================== */}


                </div>
                <div className="news-section">

                    <div className="token-container">

                        <h2 className="token-card-title" style={{ fontSize: "28px", marginBottom: "24px" }}>
                            Latest AGCX News
                        </h2>
                        <div className="news-grid">
                            <div className="news-card">
                                <div className="news-card-top-border purple"></div>
                                <span className="news-category-badge purple">Exchange</span>
                                <h3>AGCX Token Listed on Top-Tier Exchange</h3>
                                <span className="news-date">Jul 18, 2025</span>
                            </div>

                            <div className="news-card">
                                <div className="news-card-top-border green"></div>
                                <span className="news-category-badge green">Staking</span>
                                <h3>New Staking Program: 60% APY Now Live for AGCX Holders</h3>
                                <span className="news-date">Jul 15, 2025</span>
                            </div>

                            <div className="news-card">
                                <div className="news-card-top-border gold"></div>
                                <span className="news-category-badge gold">DAO</span>
                                <h3>AGCX Community Governance Q3 Vote Results Announced</h3>
                                <span className="news-date">Jul 10, 2025</span>
                            </div>
                        </div>

                    </div>

                </div>
            </div>

            <Footer />
        </>
    );
};

export default TokenPage;